<script setup>
import { useFavoriteGameStore } from "@/stores/favorite-games";

const favoriteStore = useFavoriteGameStore();

</script>    

<template>
  <section>
    <GameCarousel
      v-if="true"
      title="Meus Favoritos"
      button-link="/casino/favorites"
      :games="favoriteStore.favorites"
    ></GameCarousel>
  </section>
</template>
